function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var buildImageSize = (width, height, suffix) => ({
  width,
  height,
  suffix,
  name: ''
});
var RESIZED_EXTENSION = '.jpg';
var ORIGINAL = buildImageSize(0, 0, '');
var THUMBNAIL = buildImageSize(24, 18, '_t');
var SMALL = buildImageSize(64, 43, '_s');
var MEDIUM = buildImageSize(320, 240, '_m');
var LARGE = buildImageSize(640, 0, '_l');
var HIGH_DEFINITION = buildImageSize(1920, 1080, '_hd');
var DEALER_LOGO = buildImageSize(234, 60, '_dl');
var AGENT_STAFF_THUMBNAIL_PHOTO = buildImageSize(110, 110, '_110x110');
var AGENT_STAFF_PROFILE_PHOTO = buildImageSize(400, 400, '_180x180');
var AGENT_STAFF_NARROW_THUMBNAIL_PHOTO = buildImageSize(80, 0, '_80xN');
var PHONE_SMALL = buildImageSize(152, 92, '_ps');
var PHONE_MEDIUM = buildImageSize(560, 320, '_pm');
var PHONE_LARGE = buildImageSize(960, 560, '_pl');
var LISTING_LOGO = buildImageSize(280, 0, '_ll');
var NEW_HOMES_LOGO = buildImageSize(0, 48, '_nh');
var COVER_SHOT = buildImageSize(980, 490, '_cs');
var ImageSize = {
  ORIGINAL,
  THUMBNAIL,
  SMALL,
  MEDIUM,
  LARGE,
  HIGH_DEFINITION,
  DEALER_LOGO,
  AGENT_STAFF_THUMBNAIL_PHOTO,
  AGENT_STAFF_PROFILE_PHOTO,
  AGENT_STAFF_NARROW_THUMBNAIL_PHOTO,
  PHONE_SMALL,
  PHONE_MEDIUM,
  PHONE_LARGE,
  LISTING_LOGO,
  NEW_HOMES_LOGO,
  COVER_SHOT
};
Object.keys(ImageSize).forEach(each => {
  ImageSize[each].name = each;
});
var buildNameMap = object => Object.keys(object).reduce((result, key) => _objectSpread(_objectSpread({}, result), {}, {
  [key]: key
}), {});
var AllImageSizes = buildNameMap(ImageSize);
var ListingImageSizes = buildNameMap({
  SMALL,
  MEDIUM,
  LARGE,
  PHONE_SMALL,
  PHONE_MEDIUM,
  PHONE_LARGE,
  HIGH_DEFINITION
});
var getBaseUrl = url => {
  var lastSlash = url.lastIndexOf('/');
  var lastUnderscore = url.lastIndexOf('_');
  var lastDot = url.lastIndexOf('.');
  if (lastUnderscore > -1) {
    return url.substr(0, lastUnderscore);
  }
  if (lastDot > lastSlash) {
    return url.substr(0, lastDot);
  }
  return url;
};
var getImageUrl = (originalUrl, imageSizeName) => {
  var imageSize = ImageSize[imageSizeName];
  if (!imageSize || !originalUrl) {
    return originalUrl;
  }
  var baseUrl = getBaseUrl(originalUrl);
  return "".concat(baseUrl).concat(imageSize.suffix).concat(RESIZED_EXTENSION);
};
var getBestImageUrl = (originalUrl, imageSizeName, availableSizes) => {
  var target = ImageSize[imageSizeName];
  if (!target || !originalUrl) {
    return originalUrl;
  }
  if (availableSizes.includes(imageSizeName)) {
    return getImageUrl(originalUrl, imageSizeName);
  }
  var bestMatch = ImageSize.ORIGINAL;
  availableSizes.forEach(each => {
    var currentSize = ImageSize[each];
    if (currentSize.width <= target.width && currentSize.width > bestMatch.width) {
      bestMatch = currentSize;
    }
  });
  return getImageUrl(originalUrl, bestMatch.name);
};
export { AllImageSizes, ListingImageSizes, getImageUrl, getBestImageUrl };